import { Plane } from "@babylonjs/core/Maths/math.plane";
import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { Util } from '../utils/Util';
import { RoomElement } from './../mdl/RoomElement';
import { BoundingBox } from '@egr/wcf/modules/core/mdl';
import { EPSILON } from '@egr/wcf/modules/utils/math';
import { SnapLine, SnapPoint } from '@egr/wcf/modules/core/tool';
import { VECTOR2_X, VECTOR2_Y, projectPointOnPlane, intersectLineLine2 } from '@egr/wcf/modules/core/utils/MathUtils';
import { contains } from '@egr/wcf/modules/utils/array';
export class RoomElementSnapping {
    constructor(pRoomManager) {
        this.mRoomManager = pRoomManager;
        this.mApp = pRoomManager.app;
        this.mSnapAxes = new Array();
        this.mSnapPoints = new Array();
        this.mActiveSnapLines = [null, null];
        this.mSnapLineFeedbacks = [null, null];
        this.mRoomElement = null;
        this.mBasePoint = null;
        this.mBasePointX = null;
        this.mBasePointY = null;
        this.mBaseAxis = null;
        this.mBaseAxisX = null;
        this.mBaseAxisY = null;
        this.mPickPlane = new Plane(0, 1, 0, 0.02);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    prepareSnapping(pRE, pCurrentPoint) {
        this.clear();
        this.mRoomElement = pRE != null ? pRE : null;
        if (pRE != null && pRE.type === "Grid") {
            this.addGridSnap(pRE);
            return;
        }
        if (this.mRoomElement != null && pCurrentPoint != null) {
            this.mBasePoint = Util.to2d(pCurrentPoint);
            let tBasePoint3d = Util.to3d(this.mBasePoint);
            this.mBasePointX = this.mBasePoint.add(VECTOR2_X);
            this.mBasePointY = this.mBasePoint.add(VECTOR2_Y);
            this.mBasePointXY = this.mBasePoint.add(VECTOR2_X);
            this.mBasePointXY = this.mBasePointXY.add(VECTOR2_Y);
            this.mBasePoint_XY = this.mBasePoint.subtract(VECTOR2_X);
            this.mBasePoint_XY = this.mBasePoint_XY.add(VECTOR2_Y);
            // this.mBaseAxis = new SnapLine(Util.to3d(this.mRoomElement.startPoint), Util.to3d(this.mRoomElement.endPoint));
            // this.mSnapAxes.push(this.mBaseAxis);
            //x and y axes and 45°
            this.mBaseAxisX = new SnapLine(tBasePoint3d, Util.to3d(this.mBasePointX));
            this.mSnapAxes.push(this.mBaseAxisX);
            this.mBaseAxisY = new SnapLine(tBasePoint3d, Util.to3d(this.mBasePointY));
            this.mSnapAxes.push(this.mBaseAxisY);
            this.mBaseAxisXY = new SnapLine(tBasePoint3d, Util.to3d(this.mBasePointXY));
            this.mSnapAxes.push(this.mBaseAxisXY);
            this.mBaseAxis_XY = new SnapLine(tBasePoint3d, Util.to3d(this.mBasePoint_XY));
            this.mSnapAxes.push(this.mBaseAxis_XY);
        }
        else {
            this.mBasePoint = null;
            this.mBasePointX = null;
            this.mBasePointY = null;
            this.mBaseAxis = null;
            this.mBaseAxisX = null;
            this.mBaseAxisY = null;
            this.mBasePointXY = null;
            this.mBaseAxisXY = null;
            this.mBasePoint_XY = null;
            this.mBaseAxis_XY = null;
        }
        for (let tRE of this.mRoomManager.RoomElements) {
            if (tRE === this.mRoomElement)
                continue;
            this.addRoomElementSnap(tRE);
        }
        // other elements
        this.prepareBoundsSnap();
        //add wall edges
        for (let tWall of this.mRoomManager.walls) {
            for (let tEdge of tWall._edges)
                this.addPointSnap(Util.to3d(tEdge));
        }
        //add wall intersection points
        if (this.mBasePoint != null && this.mBasePointX != null && this.mBasePointY != null) {
            this.checkLargeAreaIntersection(Util.to3d(this.mBasePoint), Util.to3d(this.mBasePointX));
            this.checkLargeAreaIntersection(Util.to3d(this.mBasePoint), Util.to3d(this.mBasePointY));
        }
        // add 2d shape edges
        for (let tRE of this.mRoomManager.RoomElements) {
            if (tRE == null)
                continue;
            if (tRE.Params.ElementPoints == null || tRE.Params.ElementPoints.length === 0)
                continue;
            let tEPos = tRE.node.position;
            for (let tP of tRE.Params.ElementPoints)
                this.addPointSnap(tP.add(tEPos));
        }
    }
    snap(pPos, pView) {
        //snap on points
        let tPoint = SnapPoint.Snap(pPos, this.mSnapPoints, pView);
        if (tPoint != null) {
            this.updateSnapFeedback(0, tPoint._snapLine1);
            this.updateSnapFeedback(1, tPoint._snapLine2);
            return (tPoint);
        }
        //snap on wall endings
        let tPos2d = Util.to2d(pPos);
        for (let tWall of this.mRoomManager.walls) {
            let tHT = tWall.thickness * 0.5;
            let tDist = Vector2.Distance(tPos2d, tWall.startPoint);
            if (tDist <= tHT)
                return (Util.to3d(tWall.startPoint));
            tDist = Vector2.Distance(tPos2d, tWall.endPoint);
            if (tDist <= tHT)
                return (Util.to3d(tWall.endPoint));
        }
        //snap on RoomElement points
        /*
        for (let tRE of this.mRoomManager.RoomElements) {
            if (tRE === this.mRoomElement || tRE.Params.ElementPoints == null)
                continue;

            let tHT = 0.1;

            for (let tP of tRE.Params.ElementPoints) {
                let tDist = Vector3.Distance(pPos, tP);
                if (tDist <= tHT)
                    return (tP);
            }
        }
        */
        //snap on lines
        let tResult = SnapLine.Snap(pPos, this.mSnapAxes, pView);
        if (tResult != null) {
            this.updateSnapFeedback(0, tResult.line);
            this.updateSnapFeedback(1, null);
            return (tResult.pos);
        }
        this.updateSnapFeedback(0, null);
        this.updateSnapFeedback(1, null);
        return (pPos);
    }
    snapOnGrid(pPos, pView) {
        let tRes = {};
        tRes.hasSnapped = false;
        tRes.snapPos = pPos.clone();
        //snap on points
        let tPoint = SnapPoint.Snap(pPos, this.mSnapPoints, pView, 30);
        if (tPoint != null) {
            this.updateSnapFeedback(0, tPoint._snapLine1);
            this.updateSnapFeedback(1, tPoint._snapLine2);
            tRes.hasSnapped = true;
            tRes.snapPos = tPoint.clone();
        }
        return (tRes);
    }
    clear() {
        this.mRoomElement = null;
        this.mSnapAxes = new Array();
        this.mSnapPoints = new Array();
        this.updateSnapFeedback(0, null);
        this.updateSnapFeedback(1, null);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    prepareBoundsSnap() {
        if (this.mRoomManager.view == null)
            return;
        //get snapping data of other elements
        for (let tElement of this.mApp.model.elements) {
            if (tElement.isSelected)
                continue;
            if ((tElement instanceof RoomElement) && (tElement.type === "WallSideDummy"))
                continue;
            let tBounds = tElement.boundingBoxVisible;
            let tBPoints = tBounds.getPoints(tElement.worldTransform);
            for (let i = 0; i < 8; ++i) {
                tBPoints[i] = projectPointOnPlane(tBPoints[i], this.mPickPlane);
                if (!contains(this.mSnapPoints, tBPoints[i]))
                    this.mSnapPoints.push(tBPoints[i]);
            }
            for (let tEdge of BoundingBox.EDGES) {
                let tPoint1 = tBPoints[tEdge[0]];
                let tPoint2 = tBPoints[tEdge[1]];
                if (tPoint1.equalsWithEpsilon(tPoint2, EPSILON))
                    continue;
                let tSnapLine = new SnapLine(tPoint1, tPoint2, true);
                if (!contains(this.mSnapAxes, tSnapLine))
                    this.mSnapAxes.push(tSnapLine);
            }
        }
    }
    addGridSnap(pRE) {
        let tgXH = pRE.gridCellSize.x * 0.5;
        const tgYH = pRE.gridCellSize.y * 0.5;
        const tgXQ = tgXH * 0.5;
        const tgYQ = tgYH * 0.5;
        const tW = pRE.width;
        const tD = pRE.depth;
        const tWH = tW * 0.5;
        const tDH = tD * 0.5;
        let tlz = true;
        for (let z = -tDH; z <= tDH + tgYQ; z += tgYH) {
            tgXH = tlz ? pRE.gridCellSize.x * 0.5 : pRE.gridCellSize.x;
            for (let x = -tWH; x <= tWH + tgXQ; x += tgXH) {
                let tsp = new Vector3(x, 0, z);
                tsp = Vector3.TransformCoordinates(tsp, pRE.transform);
                this.addPointSnap(tsp);
            }
            tlz = !tlz;
        }
    }
    addRoomElementSnap(pRE) {
        /*
        let tSnapAxis = new SnapLine(Util.to3d(pRE.startPoint), Util.to3d(pRE.endPoint));
        this.mSnapAxes.push(tSnapAxis);

        let tM_SP = pRE.startPoint;
        let tM_SPx = tM_SP.add(VECTOR2_X);
        let tM_SPy = tM_SP.add(VECTOR2_Y);

        let tM_SP_ax = new SnapLine(Util.to3d(tM_SP), Util.to3d(tM_SPx));
        this.mSnapAxes.push(tM_SP_ax);
        let tM_SP_ay = new SnapLine(Util.to3d(tM_SP), Util.to3d(tM_SPy));
        this.mSnapAxes.push(tM_SP_ay);

        let tM_EP = pRE.endPoint;
        let tM_EPx = tM_EP.add(VECTOR2_X);
        let tM_EPy = tM_EP.add(VECTOR2_Y);

        let tM_EP_ax = new SnapLine(Util.to3d(tM_EP), Util.to3d(tM_EPx));
        this.mSnapAxes.push(tM_EP_ax);
        let tM_EP_ay = new SnapLine(Util.to3d(tM_EP), Util.to3d(tM_EPy));
        this.mSnapAxes.push(tM_EP_ay);


        //intersection with base axes
        if (this.mRoomElement != null) {
            if (!isParallel2(this.mRoomElement.startPoint, this.mRoomElement.endPoint, pRE.startPoint, pRE.endPoint)) {
                let tIsec = intersectLineLine2(this.mRoomElement.startPoint, this.mRoomElement.endPoint, pRE.startPoint, pRE.endPoint);
                if (tIsec != null) {
                    let tSnapPoint = Util.to3d(tIsec);
                    (tSnapPoint as any)._snapLine1 = tSnapAxis;
                    (tSnapPoint as any)._snapLine2 = this.mBaseAxis;
                    this.mSnapPoints.push(tSnapPoint);
                }
            }

            if (this.mBasePoint != null && this.mBasePointX != null && this.mBasePointY != null) {
                if (!isParallel2(this.mBasePoint, this.mBasePointX, pRE.startPoint, pRE.endPoint)) {
                    let tIsec = intersectLineLine2(this.mBasePoint, this.mBasePointX, pRE.startPoint, pRE.endPoint);
                    if (tIsec != null) {
                        let tSnapPoint = Util.to3d(tIsec);
                        (tSnapPoint as any)._snapLine1 = tSnapAxis;
                        (tSnapPoint as any)._snapLine2 = this.mBaseAxisX;
                        this.mSnapPoints.push(tSnapPoint);
                    }
                }

                if (!isParallel2(this.mBasePoint, this.mBasePointY, pRE.startPoint, pRE.endPoint)) {
                    let tIsec = intersectLineLine2(this.mBasePoint, this.mBasePointY, pRE.startPoint, pRE.endPoint);
                    if (tIsec != null) {
                        let tSnapPoint = Util.to3d(tIsec);
                        (tSnapPoint as any)._snapLine1 = tSnapAxis;
                        (tSnapPoint as any)._snapLine2 = this.mBaseAxisY;
                        this.mSnapPoints.push(tSnapPoint);
                    }
                }
            }
        }
        */
    }
    addPointSnap(pPoint) {
        this.mSnapPoints.push(pPoint);
    }
    checkLargeAreaIntersection(pPoint1, pPoint2) {
        for (let tWall of this.mRoomManager.walls) {
            let tWP0 = tWall._edges[0];
            let tWP1 = tWall._edges[1];
            let tWP2 = tWall._edges[2];
            let tWP3 = tWall._edges[3];
            let tLP1 = Util.to2d(pPoint1);
            let tLP2 = Util.to2d(pPoint2);
            let tLdir = Util.to2d((pPoint2.subtract(pPoint1)).normalize());
            tLP1 = tLP1.subtract((tLdir).scale(1000));
            tLP2 = tLP2.add(tLdir.scale(1000));
            // edge line 0-1
            let tintersectionPoint = intersectLineLine2(tWP0, tWP1, tLP1, tLP2);
            if (tintersectionPoint != null)
                this.mSnapPoints.push(Util.to3d(tintersectionPoint));
            // edge line 1-2
            tintersectionPoint = intersectLineLine2(tWP1, tWP2, tLP1, tLP2);
            if (tintersectionPoint != null)
                this.mSnapPoints.push(Util.to3d(tintersectionPoint));
            // edge line 2-3
            tintersectionPoint = intersectLineLine2(tWP2, tWP3, tLP1, tLP2);
            if (tintersectionPoint != null)
                this.mSnapPoints.push(Util.to3d(tintersectionPoint));
            // edge line 3-0
            tintersectionPoint = intersectLineLine2(tWP3, tWP0, tLP1, tLP2);
            if (tintersectionPoint != null)
                this.mSnapPoints.push(Util.to3d(tintersectionPoint));
        }
    }
    updateSnapFeedback(pIndex, pSnapLine) {
        /*
        //dispose current feedback
        if (pSnapLine == null || pSnapLine != this.mActiveSnapLines[pIndex]) {
            if (this.mSnapLineFeedbacks[pIndex] != null) {
                this.mSnapLineFeedbacks[pIndex]!.dispose();
                this.mSnapLineFeedbacks[pIndex] = null;
            }
        }

        //create new
        if (pSnapLine != null) {
            if (pSnapLine != this.mActiveSnapLines[pIndex]) {
                this.mActiveSnapLines[pIndex] = pSnapLine;
                this.mSnapLineFeedbacks[pIndex] = this.createSnapAxisFeedback(pSnapLine);
            }
        } else {
            this.mActiveSnapLines[pIndex] = null;
        }
        */
    }
}
